import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api/api";
import { logo } from "../assets/images";

const EmailReset = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  // const [checkPwd, setCheckPawd] = useState(false);
  // const navigate = useNavigate();

  // const handleCheck = () => {
  //   setCheckPawd(!checkPwd);
  // };

  const isValidate = () => {
    let isProceed = true;
    if (formData.email.length === 0) {
      isProceed = false;
      toast.warn("Please enter a email");
    }
    return isProceed;
  };


  const onSubmit = async (e) => {
    // console.log("e", formData);
    e.preventDefault();

    if (isValidate()) {
      try {
        const response = await api.post("/auths/email_init", {
          email: formData.email.trim(),
        });

        if (response.status === 200) {
          toast.success(`${response.data.message}`);
        } else {
          toast.error(`${response.data.message}`);
        }

      } catch (err) {

        toast.error(`${err.message}`);
      }
    }
  };

  return (
    <div className="h-screen">
      <Link to="/" className="btn btn-circle m-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="m12.718 4.707-1.413-1.415L2.585 12l8.72 8.707 1.413-1.415L6.417 13H20v-2H6.416l6.302-6.293z" />
        </svg>
      </Link>
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="200"
        className="p-4"
      >
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-20 rounded-lg w-auto"
              src={logo}
              alt="Moide Ferme"
            />
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Email de réinitialisation
            </h2>
          </div>
        </div>

        <div className=" sm:mx-auto sm:w-full sm:max-w-lg bg-white p-8">
          <form className="space-y-6" onSubmit={onSubmit}>
            <label className="form-control  w-full ">
              <div className="label">
                <span className="label-text">Email</span>
              </div>
              <div className="flex items-center gap-2 input input-bordered w-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  className="w-4 h-4 opacity-70"
                >
                  <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                  <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                </svg>

                <input
                  type="email"
                  placeholder="Email address"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="grow text-gray-900 placeholder:text-gray-400  sm:text-sm sm:leading-6"
                />
              </div>
            </label>


            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-black p-3 leading-6 text-white  hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Envoyé
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailReset;
